import { PromoComponent } from '@/mainComponent/PromoComponent';
import { ITournament } from '@/mainComponent/store/interfaces/ITournament';
import { IAchievement } from '@/mainComponent/store/interfaces/IAchievement';
import { IAchievementFS } from '@/mainComponent/store/interfaces/IAchievementFS';
import { IAchievementBG } from '@/mainComponent/store/interfaces/IAchievementBG';

class TimerController {
  protected achievementFinishedTimerId: any;
  protected achievementClosedTimerId: any;
  protected tournamentTimerId: any;

  protected allowed(): boolean {
    return (
      this.store.promo.isTournament ||
      this.store.promo.isAchievement ||
      this.store.promo.isAchievementFS ||
      this.store.promo.isAchievementBG
    );
  }

  startPromo(): void {
    if (!this.allowed()) return;

    switch (true) {
      case this.store.promo.isTournament:
        this.startTournament();
        break;
      case this.store.promo.isAchievement || this.store.promo.isAchievementFS || this.store.promo.isAchievementBG:
        this.startAchievement();
    }
  }

  protected startAchievement(): void {
    if (this.achievementFinishedTimerId) {
      clearTimeout(this.achievementFinishedTimerId);
      this.achievementFinishedTimerId = null;
    }
    if (this.achievementClosedTimerId) {
      clearTimeout(this.achievementClosedTimerId);
      this.achievementClosedTimerId = null;
    }
    this.achievementFinishedTimerId = setInterval(this.achievementFinishedTimerCallback.bind(this), 1000);
    this.achievementClosedTimerId = setInterval(this.achievementClosedTimerCallback.bind(this), 1000);
  }

  protected startTournament(): void {
    if (this.tournamentTimerId) {
      clearTimeout(this.tournamentTimerId);
      this.tournamentTimerId = null;
    }
    this.tournamentTimerId = setInterval(this.tournamentTimerCallback.bind(this), 1000);
  }

  protected achievementFinishedTimerCallback(): void {
    if (!this.store.promo.isAchievement && !this.store.promo.isAchievementFS && !this.store.promo.isAchievementBG) {
      this.finishAchievement();
      return;
    }
    const deltaTime = this.getTimeLeft(this.achievement.time.finishedAt);
    if (Math.max(deltaTime, 0) <= 0 && this.store.promo.isProgressGame()) this.finishAchievement();
  }

  protected achievementClosedTimerCallback(): void {
    if (!this.store.promo.isAchievement && !this.store.promo.isAchievementFS && !this.store.promo.isAchievementBG) {
      this.finishAchievement();
      return;
    }
    const deltaTime = this.getTimeLeft(this.achievement.time.closedAt);
    if (Math.max(deltaTime, 0) <= 0) this.finishAchievement();
  }

  protected finishAchievement() {
    clearTimeout(this.achievementFinishedTimerId);
    clearTimeout(this.achievementClosedTimerId);
    this.achievementFinishedTimerId = null;
    this.achievementClosedTimerId = null;
    this.store.promo.resetAchievement();
    game.emit(PromoComponent.events.END_ACHIEVEMENT);
  }

  protected tournamentTimerCallback(): void {
    if (!this.store.promo.isTournament) {
      this.finishTournament();
      return;
    }
    this.tournamentFinishedTimerCallback();
    const deltaTime = this.getTimeLeft(this.tournament.closedAt);
    if (Math.max(deltaTime, 0) <= 0 && !this.store.promo.tournamentFreeSpin) this.finishTournament();
  }

  tournamentFinishedTimerCallback(): void {
    const deltaTime = this.getTimeLeft(this.tournament.finishedAt);
    if (deltaTime <= 0 && this.tournament.stage !== 'finished') {
      (<ITournament>this.store.promo.tournament).stage = 'finished';
      game.emit(PromoComponent.events.FINISHED_TOURNAMENT);
    }
  }

  protected finishTournament(): void {
    clearTimeout(this.tournamentTimerId);
    this.tournamentTimerId = null;
    this.store.promo.resetTournament();
  }

  protected getTimeLeft(time: string): number {
    return (new Date(time).getTime() - new Date().getTime()) / 1000;
  }

  get tournament(): ITournament {
    return <ITournament>this.store.promo.tournament;
  }

  get achievement(): IAchievement | IAchievementFS | IAchievementBG {
    return (
      this.store.promo.achievement || this.store.promo.achievementFS || <IAchievementBG>this.store.promo.achievementBG
    );
  }

  get store() {
    return game.store;
  }
}

export { TimerController };
